import React from "react";
import SEO from "../components/SEO";
import PropTypes from "prop-types";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import WorkData from "../data/work/workDetails.json";
import WorkDetailsContainer from "../container/Work/WorkDetailsContainer";
import ScrollToTop from "../components/ScrollToTop.jsx";

const WorkDetails = ({
  match: {
    params: { id },
  },
}) => {
  const workId = parseInt(id, 10);
  const data = WorkData.find((work) => work.id === workId);

  if (!data) {
    return (
      <React.Fragment>
        <SEO title="Product Not Found | Tawanai" />
        <Header />
        <div className="section section-padding text-center">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h2 className="title mb-4">Product Not Found</h2>
                <p className="text-muted">
                  The product you are looking for does not exist or may have been removed.
                </p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <SEO title={`${data.title.trim()} | Products | Tawanai`} />
      <Header />
      <Breadcrumb
        image="images/bg/bg1.webp"
        title={data.title}
        content="Home"
        contentTwo="Products"
      />
      <WorkDetailsContainer data={data} />
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

WorkDetails.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }),
};

export default WorkDetails;
